const resizeObserver = new ResizeObserver(entries => {
    checkBeforeAfterSliderResize();
});

function MutationPlugin(slider){
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            slider.update(slider.options, 0)
        })
    })

    const config = { childList: true }

    slider.on("created", () => {
        observer.observe(slider.container, config)
    })
    slider.on("destroyed", () => {
        observer.disconnect()
    })
}

function sliderAutoplay(slider, duration) {
    duration = duration || 2000
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
        clearTimeout(timeout)
    }
    function nextTimeout() {
        clearTimeout(timeout)
        if (mouseOver) return
            timeout = setTimeout(() => {
            slider.next()
        }, duration)
    }
    slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
        })
        slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
        })
        nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
}

function sliderNavigation(slider, navClasses, dotsClasses, dotsMode) {
    navClasses = navClasses || [];
    dotsClasses = dotsClasses || ["d-flex", "mt-4", "pt-2", "justify-content-center"];
    dotsMode = dotsMode || 'dark';
    let wrapper, dots, arrowLeft, arrowRight

    function removeActive() {
        slider.slides.forEach((slide) => {
            slide.classList.remove("active")
        })
    }

    function addActive(idx) {
        slider.slides[idx].classList.add("active")
    }

    function markup(remove) {
        wrapperMarkup(remove)
        dotMarkup(remove)
        arrowMarkup(remove)
    }

    function removeElement(elment) {
        elment.parentNode.removeChild(elment)
    }

    function createDiv(className) {
        var div = document.createElement("div")
        var classNames = className.split(" ")
        classNames.forEach((name) => div.classList.add(name))
        return div
    }

    function arrowMarkup(remove) {
        if (remove) {
            removeElement(arrowLeft)
            removeElement(arrowRight)
            return
        }
        // create right arrow
        arrowLeft = createDiv("arrow arrow--left")
        // add html to arrow
        arrowLeft.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 448 512"><path d="M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"/></svg>`;
        // add attribute
        arrowLeft.setAttribute("role", "button")
        // add style to arrow
        let arrowLeftStyle = `top: 42%;width:60px;height:60px;line-height:60px;text-align:center;background-color:#FFF;border-radius:50%;justify-content:center;align-items:center;box-shadow:0px 0px 30px rgba(0, 0, 0, 0.15);`;
            arrowLeftStyle += navClasses.includes("featured-product-sldier") ? 'right:98%;' : 'left: 49px;';
        arrowLeft.style.cssText = arrowLeftStyle;
        // add class to left arrow
        arrowLeft.classList.add(...["d-inline-block", "position-absolute"], ...navClasses)
        arrowLeft.addEventListener("click", () => slider.prev())

        // create right arrow
        arrowRight = createDiv("arrow arrow--right")
        // add html to arrow
        arrowRight.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 448 512"><path d="M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"/></svg>`;
        // add attribute
        arrowRight.setAttribute("role", "button")
        // add style to arrow
        let arrowRightStyle = `top: 42%; right: 40px;width:60px;height:60px;line-height:60px;text-align:center;background-color:#FFF;border-radius:50%;justify-content:center;align-items:center;box-shadow:0px 0px 30px rgba(0, 0, 0, 0.15);`;
        arrowRightStyle += navClasses.includes("featured-product-sldier") ? 'left:98%;' : 'right: 40px;';
        arrowRight.style.cssText = arrowRightStyle;
        // add class to left arrow
        arrowRight.classList.add(...["d-inline-block", "position-absolute"], ...navClasses)
        arrowRight.addEventListener("click", () => slider.next())

        wrapper.appendChild(arrowLeft)
        wrapper.appendChild(arrowRight)
    }

    function wrapperMarkup(remove) {
        if (remove) {
            var parent = wrapper.parentNode
            while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper)
            removeElement(wrapper)
            return
        }

        // Check if there's only 1 slide - don't create wrapper if so
        if (slider.track.details.slides.length <= 1) {
            return
        }
        
        wrapper = createDiv("navigation-wrapper")
        // add class to wrapper
        wrapper.classList.add(...["position-relative"])
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
    }

    function dotMarkup(remove) {
        if (remove) {
            removeElement(dots)
            return
        }
        dots = createDiv("dots")
        //   add class to dots
        dots.classList.add(...[...dotsClasses])
        slider.track.details.slides.forEach((_e, idx) => {

            var dotParent = createDiv("dot-parent");
            // dotParent.classList.add("mx-1");
            var dot = createDiv("dot")
            // add class to dot
            dot.classList.add("m-1")
            // dot.classList.add("mx-2")
            // add style to dot
            dot.style.background = `${dotsMode === 'dark' ? "var(--bs-transparent)" : "var(--bs-transparent)"}`
            dot.style.border = `1px solid ${dotsMode === 'dark' ? 'var(--bs-gray-300)' : 'var(--bs-white)'}`
            dot.style.borderRadius = "50%"
            dot.style.height = "15px"
            dot.style.width = "15px"
            dot.setAttribute("role", "button") // add attribute
            dot.addEventListener("click", () => slider.moveToIdx(idx))
            dotParent.appendChild(dot);
            dots.appendChild(dotParent)
        })
        if (wrapper) {
            wrapper.appendChild(dots)
        }
    }

    function updateClasses() {
      var slide = slider.track.details.rel
      slide === 0
        ? arrowLeft.classList.add("arrow--disabled")
        : arrowLeft.classList.remove("arrow--disabled")
      slide === slider.track.details.slides.length - 1
        ? arrowRight.classList.add("arrow--disabled")
        : arrowRight.classList.remove("arrow--disabled")
        Array.from(dots.children).forEach(function (dotP, idx) {
            var dot = dotP.children[0];
            let color = dotsMode === 'dark' ? 'primary' : 'white';
            if(idx === slide){
                dot.classList.add("dot--active")
                dot.classList.add(`border-${color}`)
                dot.classList.add(`bg-${color}`)
            } else {
                dot.classList.remove("dot--active")
                dot.classList.remove(`border-${color}`)
                dot.classList.remove(`bg-${color}`)
            }
        })
    }

    slider.on("created", () => {
        addActive(slider.track.details.rel)
        markup()
        updateClasses()
    })
    slider.on("optionsChanged", () => {
        markup(true)
        markup()
        updateClasses()
    })
    slider.on("slideChanged", () => {
        removeActive()
        addActive(slider.track.details.rel)
        updateClasses()
    })
    slider.on("destroyed", () => {
        markup(true)
    })
}

function sliderAdaptiveHeight(slider) {
    function updateHeight() {
        setTimeout(() => {
            slider.container.style.height = slider.slides[slider.track.details.rel].offsetHeight + "px";
        }, 100);
    }

    slider.on("created", updateHeight)
    slider.on("slideChanged", updateHeight)

    window.addEventListener("resize", updateHeight)
}

function sliderResizeObserver(slider) {
    const observer = new ResizeObserver(function () {
        slider.container.style.height = slider.slides[slider.track.details.rel].offsetHeight + "px";
    })

    slider.on("created", () => {
        observer.observe(slider.container)
    })
    slider.on("destroyed", () => {
        observer.unobserve(slider.container)
    })

    window.addEventListener("resize", () => {
        observer.disconnect();
        observer.observe(slider.container);
    })
}

// Block Home Hero Slider
window.addEventListener("DOMContentLoaded", () => {
    const homeHeroSliderContainer = document.getElementById("homeHeroSlider");
    if (homeHeroSliderContainer) {
        const homeHeroSlider = new KeenSlider("#homeHeroSlider", {
            loop: true,
            breakpoints: {
                "(min-width: 320px)": {
                    slides: { perView: 1 },
                },
            }
        }, [ 
            slider => {
                sliderNavigation(slider, ['d-none', 'd-md-flex'], ["d-flex", "justify-content-center", "position-absolute", "w-100"], 'light'),
                sliderResizeObserver(slider),
                sliderAdaptiveHeight(slider)
            }
        ])
    }
});

// Block Feature Checklist
var recommendedSearchesSliderContainer = document.getElementById("recommendedSearchesSlider");
if(recommendedSearchesSliderContainer){
    var recommendedSearchesSlider = new KeenSlider("#recommendedSearchesSlider", {
        loop: false,
        mode: "snap",
        rtl: false,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "auto", perView: 1.4, spacing: 10 },
            },
            "(min-width: 768px)": {
                loop: false,
                slides: { origin: "auto", perView: 3, spacing: 10 },
            },
        }
    }, [
        slider => {
            sliderAutoplay(slider, 5000)
        }
    ])
}

// Block Feature Checklist
var featureChecklistSliderContainer = document.getElementById("featureChecklistSlider");
if(featureChecklistSliderContainer){
    var featureChecklistSlider = new KeenSlider("#featureChecklistSlider", {
        loop: true,
        mode: "snap",
        rtl: false,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "center", perView: 1, spacing: 10 },
            },
            "(min-width: 768px)": {
                loop: false,
                slides: { origin: "auto", perView: 3, spacing: "auto" },
            },
            "(min-width: 1200px)": {
                loop: false,
                slides: { origin: "auto", perView: 3.2 },
            },
            "(min-width: 1400px)": {
                loop: false,
                slides: { origin: "auto", perView: "auto" },
            },
        }
    }, [
        slider => {
            sliderAutoplay(slider, 5000)
        }
    ])
}

// Block Featured Products
var featuredProductsSliderContainer = document.getElementById("featuredProductsSlider");
if(featuredProductsSliderContainer){
    var featuredProductsSlider = new KeenSlider("#featuredProductsSlider", {
        loop: true,
        mode: "snap",
        rtl: false,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "auto", perView: 2, spacing: 0 },
            },
            "(min-width: 576px)": {
                slides: { origin: "auto", perView: 2.14, spacing: 20 },
            },
            "(min-width: 992px)": {
                slides: { origin: "auto", perView: 3.14, spacing: 20 },
            },
            "(min-width: 1200px)": {
                slides: { origin: "auto", perView: 4, spacing: 20 },
            },
        }
    }, [
        MutationPlugin,
        slider => {
            sliderNavigation(slider, ['d-none', 'd-xxl-flex', 'flex-row', 'featured-product-sldier'], ["d-flex", "mt-4", "pt-2", "justify-content-center", "d-xxl-none"])
            sliderAutoplay(slider, 5000)
        }
    ])
}


// Block Featured Categories
var featuredProductCategoriesSliderContainer = document.getElementById("featuredProductCategoriesSlider");
if(featuredProductCategoriesSliderContainer){
    var featuredProductCategoriesSlider = new KeenSlider("#featuredProductCategoriesSlider", {
        loop: false,
        mode: "free-snap",
        rtl: false,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "auto", perView: "auto", spacing: 6 },
            },
            "(min-width: 992px)": {
                slides: { origin: "auto", perView: "auto", spacing: 16 },
            },
        }
    }, [
        slider => {

            slider.on('created', () => {
                // console.log('Product Categories Slider Created', slider);

                const productCategoriesCon = document.getElementById('featuredProductCategoriesSlider');
                const productsCon = document.getElementById('featuredProductsSlider');
                const productsConMobile = document.getElementById('mobileProducts');
                if(productCategoriesCon){
                    const WP_AJAX = productCategoriesCon.dataset.ajaxUrl;
                    const categoriesFilter = productCategoriesCon.querySelectorAll('.categories a');
                    if(categoriesFilter.length){
                        let productsLoading = false;
                        categoriesFilter.forEach((item, index) => {
                            productsLoading = false;

                            item.onclick = (e) => {
                                e.preventDefault();

                                if(e.currentTarget.classList.contains("bg-dark")){
                                    // console.log('Already active');
                                    return;
                                }

                                if(productsLoading){
                                    // console.log('Please wait... Loading products...');
                                    return;
                                }
                                productsLoading = true;

                                // console.log(slider);
                                if(slider){
                                    Array.from(slider.container?.children, (o) => {
                                        // console.log(o.children[0]);
                                        o.children[0]?.classList.add("bg-transparent", "text-dark");
                                        o.children[0]?.classList.remove("bg-dark", "text-white");
                                    });

                                    e.currentTarget.classList.add("bg-dark", "text-white");
                                    e.currentTarget.classList.remove("bg-transparent", "text-dark");
                                }

                                if(featuredProductsSlider){
                                    // console.log(featuredProductsSlider);
                                    Array.from(featuredProductsSlider.container?.children, (o) => {
                                        // console.log(o.children[0]);
                                        o.children[0].classList.add("skeleton");
                                    });
                                    Array.from(productsConMobile?.children, (o) => {
                                        // console.log(o.children[0]);
                                        o.children[0].classList.add("skeleton");
                                    });
                                }

                                const element = e.currentTarget;
                                console.log(element);
                                const slug = element?.dataset?.slug;

                                const payload = {
                                    action: 'product_category_filter',
                                    slug
                                };

                                // console.log(slug);
                                fetch(`${WP_AJAX}?${new URLSearchParams(payload)}`)
                                .then(response => response.json())
                                .then(resp => {
                                    if(resp.success){
                                        if(!element.classList.contains("loaded")){
                                            dataLayerInit('view_item_list', resp.data.dataLayers);
                                            element.classList.add("loaded");
                                            productListClicked();
                                        }
                                        const products = resp.data?.products;
                                        const productsMobile = resp.data?.products_mobile;
                                        productsCon.innerHTML = products;
                                        productsConMobile.innerHTML = productsMobile;
                                        productsLoading = false;
                                    }
                                });
                            }

                        });
                    }
                }
            })

            // console.log(slider);
            // const details = slider.details();
            // const isFirst = !details.loop && details.relativeSlide === 0;
            // const isLast = !this.loop && details.relativeSlide + details.slidesPerView === details.size;

            const sliderOverlay = document.querySelector('.cat-slider-overlay')

            const prev = document.querySelector('.prev-cat')

            prev.onclick = (e) => {
                e.preventDefault()

                slider.prev()

                if(slider.track.details.progress < 1 && sliderOverlay){
                    sliderOverlay.style.display = 'block'
                }
            }

            const next = document.querySelector('.next-cat')

            next.onclick = (e) => {
                e.preventDefault()

                slider.next()

                if(slider.track.details.progress > 1 && sliderOverlay){
                    sliderOverlay.style.display = 'none'
                }
            }

            // slider.on('dragged', () => {
            //     sliderOverlay.style.display = 'block'
            // })
            slider.on('dragEnded', () => {
                if(sliderOverlay){
                    sliderOverlay.style.display = 'none'
                }
            })
        }
    ])
}

// Block Featured Categories
var shopCategoriesSliderContainer = document.getElementById("shopCategoriesSlider");
if(shopCategoriesSliderContainer){
    var shopCategoriesSlider = new KeenSlider("#shopCategoriesSlider", {
        loop: false,
        mode: "free-snap",
        rtl: false,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "auto", perView: "auto", spacing: 16 },
            },
        }
    }, [
        slider => {

            const sliderOverlay = document.querySelector('.cat-slider-overlay')

            const prev = document.querySelector('.prev-cat')

            if(prev){
                prev.onclick = (e) => {
                    e.preventDefault()
    
                    slider.prev()
    
                    if(slider.track.details.progress < 1){
                        sliderOverlay.style.display = 'block'
                    }
                }
            }

            const next = document.querySelector('.next-cat')

            if(next){
                next.onclick = (e) => {
                    e.preventDefault()
    
                    slider.next()
    
                    if(slider.track.details.progress > 1){
                        sliderOverlay.style.display = 'none'
                    }
                }
            }


            // slider.on('dragged', () => {
            //     sliderOverlay.style.display = 'block'
            // })
            slider.on('dragEnded', () => {
                sliderOverlay.style.display = 'none'
            })
        }
    ])
}

// Block Testimonials
var testimonialSliderContainer = document.getElementById("testimonialSlider");
if(testimonialSliderContainer){
    var testimonialSlider = new KeenSlider("#testimonialSlider", {
        loop: true,
        mode: "snap",
        rtl: false,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "auto", perView: 1, spacing: 20 },
            },
            "(min-width: 576px)": {
                slides: { origin: "auto", perView: 2, spacing: 20 },
            },
            "(min-width: 992px)": {
                slides: { origin: "auto", perView: 3, spacing: 20 },
            },
            "(min-width: 1200px)": {
                slides: { origin: "auto", perView: 3, spacing: 20 },
            },
        }
    }, [
        MutationPlugin,
        slider => {
            sliderNavigation(slider, ['d-none'], ["d-flex", "d-none", "justify-content-center"])
            sliderAutoplay(slider, 5000)
        }
    ])
}

var testimonialSliderCheckContainer = document.getElementById("testimonialSliderCheck");
if(testimonialSliderCheckContainer){
    var testimonialSliderCheck = new KeenSlider("#testimonialSliderCheck", {
        loop: true,
        mode: "snap",
        rtl: false,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "auto", perView: 1, spacing: 20 },
            },
            "(min-width: 576px)": {
                slides: { origin: "auto", perView: 2, spacing: 20 },
            },
            "(min-width: 992px)": {
                slides: { origin: "auto", perView: 2, spacing: 20 },
            },
            "(min-width: 1200px)": {
                slides: { origin: "auto", perView: 2, spacing: 20 },
            },
        }
    }, [
        MutationPlugin,
        slider => {
            sliderNavigation(slider, ['d-none'], ["d-flex", "d-none", "justify-content-center"])
            sliderAutoplay(slider, 5000)
        }
    ])
}

var sliderKeenContainer = document.getElementById("sliderKeen");
if( sliderKeenContainer ) {
    var sliderKeen = new KeenSlider("#sliderKeen", {
        loop: true,
        mode: "snap",
        rtl: false,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "auto", perView: 1.7, spacing: 12 },
            },
            "(min-width: 520px)": {
                slides: { origin: "auto", perView: 3.7, spacing: 12 },
            },
            "(min-width: 768px)": {
                slides: { origin: "center", perView: 6.5, spacing: 12 },
            },
        }
    }, [
        slider => {
            sliderAutoplay(slider, 3000)

            // const prev = document.querySelectorAll('.keen-prev')
            // prev.forEach((item) => {
            //     item.onclick = (e) => {
            //         e.preventDefault()

            //         slider.prev()
            //     }
            // });
            // const next = document.querySelectorAll('.keen-next')
            // next.forEach((item) => {
            //     item.onclick = (e) => {
            //         e.preventDefault()

            //         slider.next()
            //     }
            // });
        }
    ])
}

// function ThumbnailPlugin(main) {
//     return (slider) => {
//         function removeActive() {
//             slider.slides.forEach((slide) => {
//                 slide.classList.remove("active")
//             })
//         }
//         function addActive(idx) {
//             slider.slides[idx].classList.add("active", "border", "border-2", "border-blue-500")
//         }

//         function addClickEvents() {
//             slider.slides.forEach((slide, idx) => {
//                 slide.addEventListener("click", () => {
//                     main.moveToIdx(idx)
//                 })
//             })
//         }

//         slider.on("created", () => {
//             addActive(slider.track.details.rel)
//             addClickEvents()
//             main.on("animationStarted", (main) => {
//                 removeActive()
//                 const next = main.animator.targetIdx || 0
//                 addActive(main.track.absToRel(next))
//                 slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
//             })
//             $('.prev-slide').on('click', function(e){
//                 e.preventDefault();
//                 console.log('prev');
//                 slider.prev();
//                 main.prev();
//             });
//             $('.next-slide').on('click', function(e){
//                 e.preventDefault();
//                 console.log('next');
//                 slider.next();
//                 main.next();
//             });
//         })
//     }
// }

// if($('#product-images-slider').length){
//     var productSingleSlider = new KeenSlider("#product-images-slider");
//     var productSingleThumbnails = new KeenSlider(
//         "#product-thumbnail-slider",
//         {
//             initial: 0,
//             breakpoints: {
//                 '(min-width: 320px)': {
//                     vertical: false,
//                     slides: {
//                         perView: 5,
//                         spacing: 8,
//                     },
//                 },
//                 '(min-width: 576px)': {
//                     vertical: true,
//                     slides: {
//                         perView: 6,
//                         spacing: 8,
//                     },
//                 },
//                 '(min-width: 630px)': {
//                     vertical: true,
//                     slides: {
//                         perView: 5,
//                         spacing: 10,
//                     },
//                 },
//                 '(min-width: 768px)': {
//                     vertical: true,
//                     slides: {
//                         perView: 5,
//                         spacing: 10,
//                     },
//                 },
//                 '(min-width: 992px)': {
//                     vertical: true,
//                     slides: {
//                         perView: 5,
//                         spacing: 10,
//                     },
//                 },
//                 '(min-width: 1200px)': {
//                     vertical: true,
//                     slides: {
//                         perView: 5,
//                         spacing: 14,
//                     },
//                 },
//             },
//             created: () => {
//                 // console.log('Product Images Loaded...');
//                 $('.single-prod-image-wrap').removeClass('opacity-0');
//             },
//         },
//         [ThumbnailPlugin(this.productSingleSlider)]
//     )
// }

// Block Featured Categories
// var upsellSliderContainer = document.getElementById("upsellSlider");
// if(upsellSliderContainer){
//     var upsellSlider = new KeenSlider("#upsellSlider", {
//         loop: false,
//         mode: "snap",
//         rtl: false,
//         breakpoints: {
//             "(min-width: 320px)": {
//                 slides: { origin: "auto", perView: 1.14, spacing: 20 },
//             },
//             "(min-width: 576px)": {
//                 slides: { origin: "auto", perView: 2.14, spacing: 20 },
//             },
//             "(min-width: 992px)": {
//                 slides: { origin: "auto", perView: 3.14, spacing: 20 },
//             },
//             "(min-width: 1200px)": {
//                 slides: { origin: "auto", perView: 5, spacing: 20 },
//             },
//         },
//         created: () => {
//             $('.upsell-slider-container').removeClass('opacity-0');
//         },
//     }, [
//         slider => {
//             sliderAutoplay(slider, 3000)

//             const prev = document.querySelectorAll('.keen-prev')

//             prev.forEach((item) => {
//                 item.onclick = (e) => {
//                     e.preventDefault()

//                     slider.prev()
//                 }
//             });

//             const next = document.querySelectorAll('.keen-next')

//             next.forEach((item) => {
//                 item.onclick = (e) => {
//                     e.preventDefault()

//                     slider.next()
//                 }
//             });
//         }
//     ])
// }

const horizScroll = document.querySelector('#mobileProducts');
if(horizScroll){
    let mouseDown = false;
    let startX, scrollLeft;
    let startDragging = function (e) {
        mouseDown = true;
        startX = e.pageX - horizScroll.offsetLeft;
        scrollLeft = horizScroll.scrollLeft;
    };
    
    let stopDragging = function (event) {
        mouseDown = false;
    };
    
    horizScroll.addEventListener('mousemove', (e) => {
        e.preventDefault();  if(!mouseDown) {
            return;
        }
        const x = e.pageX - horizScroll.offsetLeft;
        const scroll = x - startX;
        horizScroll.scrollLeft = scrollLeft - scroll;
    });
    
    horizScroll.addEventListener('mousedown', startDragging, false);
    horizScroll.addEventListener('mouseup', stopDragging, false);
    horizScroll.addEventListener('mouseleave', stopDragging, false);
}

//
const productSliders = () => {
    const galleryThumbnail = document.querySelector('.gallery-thumbnail');
    const galleryMain = document.querySelector('.gallery-main');
    const prevButton = document.querySelector('.prev-button');
    const nextButton = document.querySelector('.next-button');

    if (!galleryMain || !galleryThumbnail) {
        return;
    }

    // Initialize Main Slider
    const mainSlider = new KeenSlider(galleryMain, {
        slides: { perView: 1 },
        loop: true,
        slideChanged(slider) {
            updateActiveSlide(slider);
        }
    });

    /* // Initialize Thumbnail Slider (Vertical)
    const thumbSlider = new KeenSlider(galleryThumbnail, {
        slides: { 
            perView: 4,
            spacing: 16,
        },
        vertical: true,
        loop: false,
    }); */

    // Initialize Thumbnail Slider (Vertical by Default)
    let isMobile = window.innerWidth <= 992;
    const thumbSlider = new KeenSlider(galleryThumbnail, {
        slides: { 
            perView: "auto", 
            spacing: 16 
        },
        loop: false,
        vertical: !isMobile, // Vertical on Desktop, Horizontal on Mobile
    });

    /* // Update Thumbnail Scrolling Mode on Resize
    window.addEventListener("resize", () => {
        const newIsMobile = window.innerWidth <= 992;
        if (newIsMobile !== isMobile) {
            isMobile = newIsMobile;
            thumbSlider.destroy(); // Destroy old slider
            thumbSlider = new KeenSlider(galleryThumbnail, {
                slides: { 
                    perView: "auto",
                    spacing: 10 
                },
                loop: false,
                vertical: !isMobile,
            });
        }
    }); */

    // Thumbnail Click Event
    const thumbnails = document.querySelectorAll(".gallery-thumbnail .keen-slider__slide");
    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
            mainSlider.moveToIdx(index); // Fix: Correct KeenSlider function
            thumbnails.forEach(t => t.classList.remove("active"));
            thumb.classList.add("active");
        });
    });

    // Navigation Button Clicks
    prevButton.addEventListener("click", () => mainSlider.prev());
    nextButton.addEventListener("click", () => mainSlider.next());

    // 
    function updateActiveSlide(slider) {
        const currentIndex = slider.track.details.rel;

        // Remove 'active' class from all slides
        document.querySelector(".gallery-main .active")?.classList.remove("active");
        document.querySelector(".gallery-thumbnail .active")?.classList.remove("active");

        // Add 'active' class to current main image and corresponding thumbnail
        const mainSlide = galleryMain.children[currentIndex];
        const thumbSlide = galleryThumbnail.children[currentIndex];

        mainSlide?.classList.add("active");
        thumbSlide?.classList.add("active");

        // Ensure active thumbnail is in view
        thumbSlider?.moveToIdx(currentIndex);
    }

    // Set first thumbnail as active
    thumbnails[0].classList.add("active");
};

document.addEventListener("DOMContentLoaded", productSliders);